import { ReactElement } from "react";
import styled from "styled-components";
import { UserBadge } from "../../pages";
import { useLocation } from "react-router-dom";

const HeaderContainer = styled.div<{ $url?: string; }>`
  position: relative;
  display: flex;
  padding: 50px 20px 30px 20px;
  flex-direction: column;
  align-items: center;
  //gap: 20px;
  border-radius: 0px 0px 30px 30px;
  background: url(${props => `${props.$url}`}) lightgray 50% / cover no-repeat;
`;

const Header = ({ children, bgUrl }: { children: ReactElement | ReactElement[], bgUrl: string }) => {
  const location = useLocation();
  const isProfilePage = location.pathname.includes('profile');
  
  return (
    <HeaderContainer $url={bgUrl}>
      {!isProfilePage && <UserBadge />}
      {children}
    </HeaderContainer>
  )
};

export default Header;